// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3174":"3b3d8416","7025":"bf58e035","7604":"9365aa58","9677":"58363bc6"}[chunkId] + ".chunk.css";
};